module.exports = __webpack_public_path__ + "media/assets/icons/push-pin-972f9e67f153f0d7d2301ad75e32dc4d.png";